export default __webpack_public_path__ + "static/darkVectorTablet-644dad017942f4cfbffa438b892c635a.webp";